import { useQuery } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'

export function useFetchUserAdmin() {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.get('/user/admin', {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data && Array.isArray(response.data.data)) {
        return response.data.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    },
    enabled: Boolean(user && token)
  })
}
